import {Pipe, PipeTransform} from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';
import {TranslocoService} from "@ngneat/transloco";

i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'));
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/es.json'));

@Pipe({
  name: 'countryI18n'
})
export class CountryPipe implements PipeTransform {

  constructor(private i18n: TranslocoService
  ) {
  }

  transform(value: string): string {
    if (value === null) return '';
    return i18nIsoCountries.getName(value, this.i18n.getActiveLang(), {select: "official"});
  }

}
